import { render, staticRenderFns } from "./CompanySidebar.vue?vue&type=template&id=4ca46044&scoped=true"
import script from "./CompanySidebar.vue?vue&type=script&lang=ts"
export * from "./CompanySidebar.vue?vue&type=script&lang=ts"
import style0 from "./CompanySidebar.vue?vue&type=style&index=0&id=4ca46044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca46044",
  null
  
)

export default component.exports